import scrollIntoView from 'scroll-into-view';

export default function(el) {
  if (!el) return;
  const containerRect = el.getBoundingClientRect();
  if (containerRect && containerRect.top < 0) scrollIntoView(el);
}
